<template>
  <template v-if="mode === 'edit'">
    <div
      :class="[
        'py-2 signature-field',
        field.error ? 'my-2 px-2 rounded border-2 border-brand-red bg-brand-red bg-opacity-10' : ''
      ]"
      :name="field.name"
      :field-id="field.field_id"
      :required="field.required"
    >
      <template v-if="type === 'draw'">
        <div
          class="w-full border border-brand-mid-gray h-24 cursor-pointer rounded"
          @click="openModal"
        >
          <template v-if="field.value">
            <Signature
              ref="displaySignature"
              :value="JSON.parse(field.value)"
              :off="true"
              :type="field.field_id === 'signature_new' ? 'new' : 'old'"
            ></Signature>
          </template>

          <template v-else>
            <div class="m-auto w-9/12 h-4/5 border-b border-brand-mid-gray flex flex-col-reverse">
              <p class="text-brand-mid-gray text-center mb-3 text-lg">Click to Sign</p>
            </div>
          </template>
        </div>
        <div class="mt-2">
          <p
            class="cursor-pointer text-brand-green type-signature-link"
            @click="toggleType('type')"
          >
            Prefer to type your signature?
          </p>
        </div>
      </template>

      <template v-if="type === 'type'">
        <div class="w-1/2 m-auto">
          <p class="typed-signature px-1 py-2">{{ field.value }}</p>
          <SingleLineInput
            placeholder=""
            :value="field.value"
            @input="updateValue($event.target.value)"
          ></SingleLineInput>
          <div>
            <p class="cursor-pointer text-brand-green" @click="toggleType('draw')">
              Prefer to draw your signature?
            </p>
          </div>
        </div>
      </template>

      <template v-if="field.error">
        <p class="text-brand-red">{{ errorMessage }}</p>
      </template>
    </div>
  </template>
  <template v-if="mode === 'view'">
    <template v-if="field.value && !isTextSignature">
      <div class="w-full h-24 relative">
        <signature
          ref="displaySignature"
          :value="JSON.parse(field.value)"
          :off="true"
          :type="field.field_id === 'signature_new' ? 'new' : 'old'"
        ></signature>
        <div class="absolute right-0" v-if="field.signature_timestamp">
          <p class="text-brand-green">Signed at {{ field.signature_timestamp }}</p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="w-full relative">
        <p class="text-center typed-signature mx-auto">{{ field.value }}</p>
        <div class="absolute right-0" v-if="field.signature_timestamp">
          <p class="text-brand-green">Signed at {{ field.signature_timestamp }}</p>
        </div>
      </div>
    </template>
  </template>
  <template v-if="mode === 'form_edit'">
    <div class="flex flex-col w-full">
      <div class="w-full border border-brand-mid-gray h-24 cursor-pointer rounded">
        <div class="m-auto w-9/12 h-4/5 border-b border-brand-mid-gray flex flex-col-reverse">
          <p class="text-brand-mid-gray text-center mb-3 text-lg">Click to Sign</p>
        </div>
      </div>
      <div class="mt-2">
        <p class="cursor-pointer text-brand-green type-signature-link">
          Prefer to type your signature?
        </p>
      </div>
    </div>
  </template>
  <!-- TODO: Refactor modal out to its own component -->
  <TransitionRoot appear :show="modalOpen" as="template">
    <Dialog as="div" :open="modalOpen" @close="closeModal">
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div class="min-h-screen px-4 text-center flex">
          <DialogOverlay class="fixed inset-0 bg-black opacity-30" />

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="inline-block w-full max-w-screen-md p-6 m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded"
            >
              <div class="flex flex-row pb-4">
                <div class="flex-1">
                  <h3 class="text-lg leading-6 text-brand-black">Signature</h3>
                </div>
                <div class="flex-4 cursor-pointer" @click="closeModal">
                  <img class="w-3" src="@/assets/icons/close.svg" ref="close" />
                </div>
              </div>

              <div class="py-4">
                <div class="w-full border border-brand-mid-gray h-24 cursor-pointer rounded">
                  <Signature
                    ref="modalSignature"
                    :value="JSON.parse(field.value)"
                    @update="updateValue"
                    :type="field.field_id === 'signature_new' ? 'new' : 'old'"
                  ></Signature>
                </div>
              </div>

              <div class="py-4">
                <p
                  class="cursor-pointer underline text-center"
                  style="color: #989898"
                  @click="clearSignature"
                >
                  Clear signature
                </p>
              </div>

              <div class="py-4">
                <div class="m-auto w-1/2">
                  <PrimaryButton @click="closeModal">Done</PrimaryButton>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay
  //DialogTitle,
} from "@headlessui/vue"

import SingleLineInput from "../common/SingleLineInput.vue"

export default {
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    SingleLineInput
  },
  emits: ["update"],
  props: {
    field: Object,
    mode: {
      type: String
    },
    stage: {
      type: String
    }
  },
  computed: {
    isValid() {
      if (this.field.required && !this.field.value) {
        return false
      }
      return true
    },
    isTextSignature() {
      if (!this.field.value) return false
      return !(this.field.value[0] === "[" && this.field.value[1] === "{")
    }
  },
  data() {
    return {
      type: "draw",
      modalOpen: false,
      signature: null,
      errorMessage: ""
    }
  },
  created() {
    if (this.field && this.field.value) {
      if (this.field.value[0] === "[" && this.field.value[1] === "{") {
        this.type = "draw"
      } else {
        this.type = "type"
      }
    } else {
      this.type = this.isMobile ? "draw" : "type"
    }
  },
  mounted() {
    // if (this.field.value) {
    //   if (this.field.value[0] === "[" && this.field.value[1] === "{") {
    //     this.type = "draw"
    //   } else {
    //     this.type = "type"
    //   }
    // }
  },
  methods: {
    toggleType(type) {
      this.type = type
      this.$emit("update", null)
    },
    openModal() {
      this.modalOpen = true
    },
    closeModal() {
      this.modalOpen = false
    },
    updateValue(data) {
      let val
      // when signature is type
      if (typeof data === "string") {
        val = data
      } else {
        // when signature is draw
        val = JSON.stringify(data)
      }

      this.$emit("update", val)
    },
    clearSignature() {
      this.$refs.modalSignature.clear()
      this.$emit("update", null)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = "This field is required."
        }
      } else {
        this.errorMessage = ""
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Yellowtail&display=swap");

.typed-signature {
  font-family: "Yellowtail", cursive;
  font-size: 30px;
}
</style>
